// @ts-nocheck
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import BlogFeaturedCategoryTile, {
    BlogFeaturedCategoryTilePresentationProps,
} from "@store/Library/Components/Toolkit/Blog/BlogFeaturedCategoryTile";
import useExpandProps, { ExpandStyles } from "@toolkit/Framework/Common/Hooks/useExpandProps";
import { pxToRemArray } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { gridGapStyles } from "@toolkit/Themes/common/mixins";
import React, { FC } from "react";
import { css } from "styled-components";

export interface BlogFeaturedCategoryListPresentationProps extends ExpandStyles<BlogFeaturedCategoryListStyles> {}

interface BlogFeaturedCategory {
    id: string;
    image: string;
    text: string;
    title: string | undefined;
    url: string | undefined;
}
export interface BlogFeaturedCategoryListProps extends BlogFeaturedCategoryListPresentationProps {
    categories: BlogFeaturedCategory[];
    readMoreLabel: string;
}

export interface BlogFeaturedCategoryListStyles {
    gridContainer?: GridContainerProps;
    gridItem?: GridItemProps;
    blogFeaturedCategoryTile?: BlogFeaturedCategoryTilePresentationProps;
}

export const blogFeaturedCategoryListStyles: BlogFeaturedCategoryListStyles = {
    gridContainer: {
        offsetProps: { as: "ul" },
        gap: 0,
        css: css`
            ${gridGapStyles(pxToRemArray([8, 12, 18, 24, null]))}
        `,
    },
    gridItem: {
        as: "li",
        width: [12, 6, 6, 6, 6],
    },
};

const BlogFeaturedCategoryList: FC<BlogFeaturedCategoryListProps> = ({
    categories,
    readMoreLabel,
    extendedStyles,
    overridedStyles,
}) => {
    const styles = useExpandProps(blogFeaturedCategoryListStyles, extendedStyles, overridedStyles);

    if (!categories.length) {
        return null;
    }

    return (
        <GridContainer {...styles.gridContainer}>
            {categories.map(category => {
                const { id, image, url, text, title } = category;

                if (typeof url === "undefined" || typeof title === "undefined") {
                    return null;
                }

                return (
                    <GridItem key={id} {...styles.gridItem}>
                        <BlogFeaturedCategoryTile
                            {...styles.blogFeaturedCategoryTile}
                            imagePath={image}
                            linkHref={url}
                            readMoreLabel={readMoreLabel}
                            subheading={text}
                            title={title}
                        />
                    </GridItem>
                );
            })}
        </GridContainer>
    );
};

export default BlogFeaturedCategoryList;
